import styled from 'styled-components'
import { Icon } from 'ui/components/Icon'

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
`

const WrappedIcon = styled(Icon)<{ size: number }>`
  width: ${(p) => `${p.size}px`};
  height: ${(p) => `${p.size}px`};
  position: absolute;
  margin: 0 12px;
  z-index: 1;
`

const SCInput = styled.input<{
  error: boolean
  iconSize?: number
}>`
  position: relative;
  height: 54px;
  color: #fff;
  border: 1.5px solid ${(p) => (p.error ? p.theme.uiKit.colors.theme.negative.main : 'transparent')};
  border-radius: 6px;
  overflow: hidden;
  width: 100%;
  font-size: 13px;
  background-color: ${(p) =>
    p.error ? p.theme.uiKit.colors.theme.negative.transparent.opacity12 : 'rgba(255,255,255,0.22)'};
  padding: 8px;
  padding-left: ${(p) => (p.iconSize ? `calc(${p.iconSize}px + 24px)` : '8px')};
  margin: 0;
  outline: none;
  box-sizing: border-box;
  appearance: textfield !important;
  -moz-appearance: textfield !important;

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  ::placeholder {
    color: #fff;
  }

  :focus {
    background: ${(p) =>
      p.error ? p.theme.uiKit.colors.theme.negative.transparent.opacity12 : 'transparent'} !important;
    border-color: ${(p) => (p.error ? p.theme.uiKit.colors.theme.negative.main : '#fff')} !important;
  }

  :-webkit-autofill,
  :-webkit-autofill:hover {
    -webkit-box-shadow: ${(p) => `0 0 0 30px ${p.theme.uiKit.colors.theme.brand.lightest} inset`} !important;
    -webkit-text-fill-color: white !important;
    border-color: ${(p) => p.theme.uiKit.colors.theme.brand.lightest} !important;
    filter: none !important;
  }
  :-webkit-autofill:focus {
    -webkit-box-shadow: ${(p) => `0 0 0 30px ${p.theme.uiKit.colors.theme.brand.primary} inset`} !important;
    -webkit-text-fill-color: white !important;
    border-color: #fff !important;
    filter: none !important;
  }
`

export const s = { Container, WrappedIcon, SCInput }
